<label class="ui-input-field" [class.ui-input-field-invalid]="isInvalid()">
  @if (hasLabel()) {
    <span class="ui-input-label">{{ label() }}</span>
  }
  <input
    class="ui-input-control"
    [id]="inputId()"
    [attr.name]="name()"
    [attr.type]="type()"
    [attr.autocomplete]="autocomplete()"
    [attr.inputmode]="inputMode()"
    [attr.placeholder]="placeholder()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="describedBy()"
    [attr.aria-invalid]="isInvalid() ? 'true' : null"
    [attr.maxlength]="maxLength()"
    [value]="value()"
    [disabled]="disabled()"
    [readOnly]="readonly()"
    [required]="required()"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
  />
</label>
@if (hasError()) {
  <p class="ui-input-message ui-input-message-error" [id]="errorId()">
    {{ errorText() }}
  </p>
} @else if (hasHelper()) {
  <p class="ui-input-message" [id]="helperId()">{{ helperText() }}</p>
}
